var map = {
	"./Miss_Wormwood.png": 158,
	"./rosalyn.png": 159,
	"./tracer_bullet.jpg": 160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;



/*****************
 ** WEBPACK FOOTER
 ** ./src/image ^\.\/.*$
 ** module id = 157
 ** module chunks = 0
 **/